module.exports = "/images/role-other-icon.svg?7347d7bd248cf42b5a2f96e1a753f3b1";